import { api, ApiRequestConfig } from 'api';
import { FetchConfiguratorsParams, RatingData, TSLPData } from './types';

export const fetchConfigurators = (
	url: string,
	params: FetchConfiguratorsParams,
	config?: ApiRequestConfig
): Promise<TSLPData> => api.get(url, params, config);

type FetchRatingParams = {
	regionCode: string;
	configuratorIds: number[];
};

export const fetchRating = (
	url: string,
	params: FetchRatingParams,
	config?: ApiRequestConfig
): Promise<RatingData[]> => api.post(url, params, config);
